/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2025-02-10 17:55:59
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React, { Component } from "react";
import { BsyConfig } from "../../global/BsyConfig";

import { BsyUtils } from "../../utils/Utils";
import BsyMsgBubble from "../BsyMsgBubble";
import BsySelectCheckBox, { TriggerComboCheckPane } from "../BsySelectCheckBox";
import "./index.css";

class BsyUserCheckBox extends BsySelectCheckBox {
  userValueMap = {};

  constructor(props) {
    super({
      hasSelectAll: !0,
      hasSelectEmpty: !0,
      emptySelectText: React.language("unfilled"),
      ...props,
    });
    this.isEditd = false; //记录数据是否产生变化
    this.isAllSelect = false;
    this.loadUserMap(this.state.value);
  }

  Replenish = () => {
    const { textField, valueField } = this.options;
    const { items, value } = this.state;
    let ddmap = {};
    items &&
      items.map((val) => {
        this.userValueMap[val[valueField]] = val[textField];
        ddmap[val[valueField]] = val;
      });
    var tmpdd = [];
    value &&
      value.map((data) => {
        if (data === "fx_param_empty") {
          return data;
        }
        if (!ddmap[data]) {
          if (this.userValueMap[data]) {
            tmpdd.push({
              [valueField]: data,
              [textField]: this.userValueMap[data],
            });
          }
        }
      });
    return [...tmpdd, ...items];
  };

  showCombo = (currentTarget) => {
    const {
      searchable,
      textField,
      valueField,
      allowBlank,
      hasSelectAll,
      hasSelectEmpty,
      emptySelectText,
      onCustomItem,
    } = this.options;
    const { value } = this.state;
    let width = this.element.current.offsetWidth;
    let that = this;

    //针对一些已经存储的元素做追加处理
    const items = this.Replenish();
    this.isEditd = false;

    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: (ref) => {
        if (that.showLoadingHandle) {
          that.showLoadingHandle.closeAlter();
          that.showLoadingHandle = null;
        }

        return (
          <TriggerComboCheckPane
            valueSort={true}
            items={items}
            textField={textField}
            valueField={valueField}
            searchable={searchable}
            allowBlank={allowBlank}
            onCustomItem={onCustomItem}
            hasSelectEmpty={hasSelectEmpty}
            emptySelectText={emptySelectText}
            searchValue={that.searchValue}
            hasSelectAll={hasSelectAll}
            value={value}
            onSelect={(val) => {
              that.selectItem(val);
            }}
            onSeach={this.onSeach}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: width < 150 ? 150 : width,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        that.setState(
          {
            showList: !1,
          },
          () => {
            if (that.isEditd) {
              if (that.props.onStopEdit) {
                that.props.onStopEdit(that.state.value);
              }
            }
          }
        );
        return !1;
      },
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    let props = {};

    if (!BsyUtils.compare(this.state.value, nextProps.value)) {
      if (nextProps.value && Array.isArray(nextProps.value))
        props.value = [...nextProps.value];
    }
    if (this.options.hasSelectEmpty !== nextProps.hasSelectEmpty) {
      this.options.hasSelectEmpty = nextProps.hasSelectEmpty;
      props.items = [];
    }
    if (!BsyUtils.isObjectEmpty(props)) {
      this.setState(
        {
          ...props,
        },
        () => {
          this.loadUserMap(this.state.value);
        }
      );
    }
  }

  loadUserMap = (value) => {
    let that = this;

    let c = [];
    that.userValueMap["100000000000000000000001"] = React.language(
      "widget.user.current"
    );
    that.userValueMap["anonymous"] = React.language("widget.user.anonymous");
    that.userValueMap["fx_param_empty"] = this.options.emptySelectText;
    BsyUtils.forEach(this.state.value, function (a, d) {
      that.userValueMap[d] || c.push(d);
    });

    if (!BsyUtils.isObjectEmpty(c)) {
      this.loadMemberName(c);
    }
  };

  loadMemberName = (ids) => {
    let that = this;
    React.axios("/corp/list_member_name", {
      isUserOnly: !0,
      members: ids
        .filter((item) => item)
        .map((item) => (typeof item === "string" ? item : item._id || item.id)),
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let d = res.data;
          if (d.virtually && d.virtually.length > 0) {
            BsyUtils.forEach(d.virtually, function (k, z) {
              switch (z.mode) {
                case "role":
                  d.roles || (d.roles = []);
                  d.roles.push(z);
                  break;
                case "outsider":
                  d.outsiderMember || (d.outsiderMember = []);
                  d.outsiderMember.push(z);
                  break;
                case "member":
                  d.users || (d.users = []);
                  d.users.push(z);
                  break;
                case "outsiderGroup":
                  d.outsiderGroup || (d.outsiderGroup = []);
                  d.outsiderGroup.push(z);
                  break;
                case "current":
                case "currentSub":
                  d.job_title || (d.job_title = []);
                  d.job_title.push(z);
                  break;
                case "relationUser":
                  d.userRelation || (d.userRelation = []);
                  d.userRelation.push(z);
                  break;
                case "relationDept":
                  d.deptRelation || (d.deptRelation = []);
                  d.deptRelation.push(z);
                  break;
                case "deptSub":
                case "dept":
                  d.departments || (d.departments = []);
                  d.departments.push(z);
                  break;
                default:
                  break;
              }
            });
          }
          BsyUtils.forEach(d.users, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          BsyUtils.forEach(d.outsiderMember, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          BsyUtils.forEach(d.departments, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          BsyUtils.forEach(d.dockuser, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          this.setState({});
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  showItem = () => {
    const { items, value } = this.state;
    const { valueField, textField } = this.options;
    let text = [];

    if (!value) {
      items &&
        items.map((val) => {
          this.userValueMap[val[valueField]] = val[textField];
          if (val.selected) {
            text.push(val[textField]);
          }
        });
      return text;
    } else {
      let ddmap = {};
      items &&
        items.map((val) => {
          this.userValueMap[val[valueField]] = val[textField];
          ddmap[val[valueField]] = val;
        });
      value.map((data) => {
        if (!ddmap[data]) {
          if (data === "fx_param_empty") {
            text.push(this.options.emptySelectText);
          } else {
            if (this.userValueMap[data]) {
              text.push(this.userValueMap[data]);
            } else {
              text.push(data);
            }
          }
        } else {
          if (this.userValueMap[data]) {
            text.push(this.userValueMap[data]);
          } else {
            text.push(data);
          }
        }
      });
    }

    return text;
  };
}

export default BsyUserCheckBox;
